import React from "react"
import ToPar from "./ToPar"

const LivescoringRow = ({
    match,
    cardOrder,
    position,
    positionOrder,
    roundNumber,
    sum,
    compatibleRounds,
    calculation,
    section,
    competitionId,
    teeTime,
    positionCalculationKey,
    roundColumns = null,
    days = null,
    showTotal = null
}) => {
    const isCouple = !match.team ? match.nombre.length > 1 : false
    const hasResults = null != match.contraparHcp || null != match.contraparScratch
    const positionToDisplay = position ?? positionOrder?.[cardOrder]?.[positionCalculationKey] ?? ""
    const columns = roundColumns && roundColumns.length > 0
        ? roundColumns
        : [{roundId: match.jornadaId, roundNumber, teeTime}]
    const totalVisible = null === showTotal ? 1 != roundNumber && compatibleRounds === true : showTotal

    const showElectronicCard = (inscribedId, isTeam, hasResults) => {
        if (("livescoring" === section || "ecard" === section) && hasResults) {
            cardOpener(inscribedId, isTeam ? 0 : competitionId)
        }
    }

    const holeValue = (match, key, roundTeeTime = teeTime) => {
        let holeVal = ''

        if (match.especial == null) {
            if (roundTeeTime && roundTeeTime[key]) {
                holeVal = roundTeeTime[key]
            }

            if (match.tarjetaEntregada) {
                holeVal = 'F'
            } else if (match.ultimoHoyo != null) {
                holeVal = 'H' + match.ultimoHoyo
            }
        }

        return holeVal
    }

    const roundMatch = (roundId) => {
        return days?.[roundId]?.[cardOrder] || match
    }

    return <div onClick={() => showElectronicCard(match.inscribedId, isCouple, hasResults)} className='fila' key={cardOrder}>
        <div className='zonaJugador'>
            <label className='posicion'>{ positionToDisplay }</label>
            <div className='jugador'>
                {
                    !match.team ?
                        match.nombre.map((name, i) => {
                            return (
                                <label key={i} className='nombre'>{ name }</label>
                            )
                        })

                        :

                        <b>{ match.nombre }</b>
                }
                {
                    match.team &&
                        <small className='jugadores'>
                            {
                                match.jugadores.join(' - ')
                            }
                        </small>
                }
            </div>
        </div>
        <div className='columnaPuntuacion'>
            <div className='puntuacion'>
                {
                    columns.map(column => {
                        const columnMatch = roundMatch(column.roundId)
                        const columnHasMatch = days?.[column.roundId]?.[cardOrder]

                        return (
                            <div key={column.roundId} className="puntuacionHoy">
                                <label className='hoyo'>{ columnHasMatch ? holeValue(columnMatch, cardOrder, column.teeTime) : column.teeTime?.[cardOrder] || '' }</label>
                                {
                                    columnHasMatch &&
                                        <>
                                            <ToPar
                                                toPar={'H' === calculation ? columnMatch.contraparHcp : columnMatch.contraparScratch}
                                                special={columnMatch.especial}
                                                isTotal={false}
                                            />
                                            {
                                                columnMatch.tarjetaEntregada &&
                                                    <div className="current finished">{ "H" === calculation ? columnMatch.hcp : columnMatch.scratch }</div>
                                            }
                                        </>
                                }
                            </div>
                        )
                    })
                }
                {
                    totalVisible &&
                        <div className='puntuacionTotal'>
                            <ToPar
                                toPar={'H' === calculation ? sum?.[match.clave]?.contraparHcp : sum?.[match.clave]?.contraparScratch}
                                special={sum?.[match.clave]?.especial}
                                isTotal={true}
                            />
                            {
                                match.tarjetaEntregada && sum?.[match.clave] &&
                                    <div className='current finished'>{ "H" === calculation ? sum[match.clave].hcp : sum[match.clave].scratch }</div>
                            }
                        </div>
                }
            </div>
        </div>
    </div>
}

export default LivescoringRow
